import React from 'react'
import foods from "./resturant-menu-data/menuItems.js";
import "./hero.css"
import { bg } from '../../assets/index.js';
const Hero = () => {
  return (<>
            <div style={{
            backgroundImage: `url(${bg})`,
          }} class="flex-row md:flex bg-no-repeat items-center">
                  <div class="w-full md:w-[95%] mt-20 md:h-screen h-3/5 pt-12">
                    <div class="md:mx-20 mx-16 ">
                      <h1 class="md:text-5xl text-3xl text-primary font-bold md:mt-32">Reality and imagination merge on your plate</h1>
                      <div
                        class="description w-full sm: md:w-2/3 mt-4 text-gray-500 text-md"
                      >
                        You can now see the food, on your own table and combine different side dishes with main courses, having fullcontrol of your selections.
                      </div>
                    </div>
                  </div>
                  <div class="w-full h-[50vh] md:h-[80vh]">
                        <cobotiks-viewer
                          alt="3d-model"
                          ar
                          shadow-intensity="1.89"
                          camera-controls id="test"
                          exposure="1"
                          camera-orbit="-26.63deg 43.52deg 1.563m"
                          field-of-view="30deg"
                          src="https://dpwkb35ettjxj.cloudfront.net/models/cobotiks/FastFoodBeverage/FastFoodWithAnnot.glb"
                      >
                      </cobotiks-viewer>
                  </div>
                </div>
    </>
  )
}

export default Hero;